<template>
<!--道路信息表单页面-->
<el-form class="roadForm" status-icon ref="road" label-width="45%" v-loading="loading">

  <div class="formDo">
    <!--按钮操作区-->
    <el-form-item label="道路信息编号">
      <el-select v-model="roadNum" :disabled="number">
        <el-option v-for="item in road_num" :key="item.value" :label="item.label" :value="item.label"></el-option>
      </el-select>
    </el-form-item>
    <el-button v-if="this.roadNum === '道路信息二'" @click="copyFrom">复制道路信息一</el-button>
  </div>

  <div class="formMsg" v-if="this.roadNum === '道路信息一'">
    <!--表单组-->
    <road-env :formItem="road"></road-env>
  </div>

  <div class="formMsg" v-if="this.roadNum === '道路信息二'">
    <!--表单组-->
    <road-copy :form-item="road_copy"></road-copy>
  </div>

  <div class="formButton">
    <!--按钮操作区-->
    <el-tooltip class="item" effect="dark" content="请继续完成道路信息二" placement="top" :disabled="!(next === true && number === false)">
      <el-button-group>
        <el-button @click="lastStep"><i class="el-icon-arrow-right el-icon-arrow-left"></i>上一步</el-button>
        <el-button icon="el-icon-check" :plain="true" @click="submit">保存信息</el-button>
        <el-button :disabled="next" @click="nextStep">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </el-button-group>
    </el-tooltip>
  </div>

</el-form>
</template>

<script>
import qs from 'qs'
import bus from './bus'
import arrayData from '../assets/javascript/dataProcess'
import roadEnv from '../assets/components/form'
import roadCopy from '../assets/components/form'

export default {
  name: "newCase_road",
  components:{
    roadEnv,
    roadCopy
  },
  data() {
    return {
      /*加载动画*/
      loading: false,

      number: true,
      next: true,
      roadNum: '道路信息一',
      road_num: [{
          label: "道路信息一",
          value: "1"
        },
        {
          label: "道路信息二",
          value: "2"
        }
      ],
      road: [],
      road_copy: []
    }
  },
  methods: {
    submit() {
      let formdata = {};
      if (this.roadNum === "道路信息一") {
        if (this.road[0].value === '' || this.road[1].value === '' || this.road[2].value === '') {
          for (let i = 0; i < 3; i++) {
            if (this.road[i].value === "") {
              this.$set(this.road[i], "warning", 1);
              this.$set(this.road[i], "warningMsg", "必填信息不得为空");
            }
          }
        } else {
          for (let i = 0; i < this.road.length; i++) {
            let value = this.road[i].value;
            formdata[this.road[i].name] = value;
          }
          this.loading = true;
          this.$http.post(
              '/nais/road',
              qs.stringify(formdata), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            )
            .then((res) => {
              this.$message({
                message: "道路信息一保存成功",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.number = false;
              this.$nextTick(
                this.loading = false,
              );
            })
            .catch((err) => {
              console.log(err);
              this.$nextTick(
                this.loading = false,
              );
            });
        }
      } else {
        if (this.road_copy[0].value === '' || this.road_copy[1].value === '' || this.road_copy[2].value === '') {
          for (let i = 0; i < 3; i++) {
            if (this.road_copy[i].value === "") {
              this.$set(this.road_copy[i], "warning", 1);
              this.$set(this.road_copy[i], "warningMsg", "必填信息不得为空");
            }
          }

        } else {
          for (let i = 0; i < this.road_copy.length; i++) {
            formdata[this.road_copy[i].name] = this.road_copy[i].value;
          }
          this.$http.post(
              '/nais/road',
              qs.stringify(formdata), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            )
            .then((res) => {
              this.$message({
                message: "道路信息二保存成功",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.next = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    copyFrom() {
      for (let i = 0; i < this.road.length; i++) {
        let formOne = this.road;
        let formTwo = this.road_copy;
        formTwo[i].value = formOne[i].value;
      }
      this.road_copy[1].value = "2";
    },
    nextStep() {
      bus.$emit('roadNext', 3);
    },
    lastStep() {
      bus.$emit('roadLast', 1);
    }
  },
  created() {
    let length1 = arrayData.data1.road.length;
    for (let i = 0; i < length1; i++) {
      arrayData.data1.road[i].value = '';
    }
    let length2 = arrayData.data1.road_copy.length;
    for (let i = 0; i < length2; i++) {
      arrayData.data1.road_copy[i].value = '';
    }
    /*渲染数组*/
    this.road = arrayData.data1.road;
    this.road_copy = arrayData.data1.road_copy;
    bus.$on('caseNumber', msg => {
      this.road[0].value = msg;
      this.road_copy[0].value = msg;
    });
  }
}
</script>

<style scoped>
.roadForm {
  width: 98%;
  height: 89%;
  margin-top: 0.5%;
  background-color: #F5F7FA;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.formDo {
  height: 10%;
  width: 700px;
  margin-top: 10px;
  display: flex;
  padding-left: 8%;
}

.formDo .el-button {
  height: 40px;
  margin-left: 20px;
}

.formMsg {
  width: 100%;
  height: 78%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  overflow-y: scroll;
  padding-right: 10px;
}

.formButton {
  width: 100%;
  height: 10%;
  margin-top: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form-item {
  width: 33%;
}

.el-form-item__content {
  width: calc(100% - 45%);
}

.el-input {
  width: 100%;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/data/newCase_road.vue